import type { QueryClient } from '@tanstack/react-query';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/**
 * Consultas en caché que son de una persona (su cuenta, su ruta, su pasaporte, sus marcas de
 * visitada o de voto): las llaves con `['me', ...]`, las que llevan el usuario (`{ user }` o el id
 * al final) y el detalle de estación con `user_context`. Lo público (pines sin sesión, bebidas,
 * reseñas, contenido) no cuenta.
 */
export function isUserSpecificQuery(queryKey: readonly unknown[], data: unknown): boolean {
  const [root] = queryKey;
  if (root === 'me') return true;
  if (root === 'bootstrap') return queryKey[1] !== null && queryKey[1] !== undefined;
  if (root === 'rankings') return typeof queryKey[3] === 'string';
  if (queryKey.some((part) => isRecord(part) && part.user !== null && part.user !== undefined)) return true;
  if (root === 'stations' && queryKey[1] === 'detail') return isRecord(data) && data.user_context !== null && data.user_context !== undefined;
  return false;
}

/**
 * Borra de la caché (y así del almacenamiento offline) todo lo que es de una persona: al perderse la
 * sesión en el servidor o cuando entra otra persona en el mismo navegador.
 */
export function purgeUserData(queryClient: QueryClient): void {
  queryClient.removeQueries({ predicate: (query) => isUserSpecificQuery(query.queryKey, query.state.data) });
}
